import type { QueryClient, QueryKey } from '@tanstack/react-query';

export function refetchSelectedSharedPmConnection({
  queryClient,
  queryKey,
  setIsPolling,
}: {
  queryClient: QueryClient;
  queryKey: QueryKey;
  setIsPolling: (value: boolean) => void;
}) {
  // Provider auth is temporarily duplicated onto installation rows, while
  // settings remain per GitHub installation. A realtime payload may describe a
  // sibling row that shares auth, so refetch the selected row instead of
  // writing the payload into this settings tab's cache.
  queryClient.invalidateQueries({ queryKey });
  setIsPolling(false);
}
